// Thin wrapper around hard browser navigation so callers can be tested
// without a real page load.
export function replaceLocation(href: string): void {
  window.location.replace(href)
}
